/**
 * @module sendingEmailAddress.transformer
 */

/**
 * Transform sendingDomains from the server form to the front-end form.
 * This is a virtualized entities as it connect sending domains and sending addresses together
 */
const sendingEmailAddressesFrom = (sendingDomains) => {
  const emails = sendingDomains.reduce((addresses, domain) => {
    const allAddresses = [...addresses];
    domain.sendingEmailAddress.forEach((address) => {
      if (!allAddresses.find((addr) => addr.localPart === address.localPart)) {
        allAddresses.push({
          label: `${address.localPart}@${domain.domain}`,
          id: address.id,
        });
      }
    });
    return allAddresses;
  }, []);
  return emails;
};

export { sendingEmailAddressesFrom };
